import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Divider, Button, Spin, message, Alert } from 'antd';

import { getExamDetail, getListRecord, getUserInfo, checkExam, submitExamAuto } from '../../Admin/apis/exam-manage';
import { judgeIsLogin } from "../../common/utils";
import Logo from "../../assets/images/qingcloud_new.svg";

import './index.less';
import { getUserAutoExamGrade, getUserGrade } from './api';

let timer: any;
let initTimeLength = 3;

function BeforeAnswer() {
  const [testInfo, setTestInfo] = useState<any>({});
  const [testRecordList, setTestRecordList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [timeLength, setTimeLength] = useState(initTimeLength);
  const history = useHistory();
  const urlParams: { id: string } = useParams();
  const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify({})) || {};
  const [grade, setGrade]=useState(null);
  const [preExamInfo,setPreExamInfo]=useState<any>();
  const [preExamGrade,setPreExamGrade]=useState<any>();
  const [disableBtnFlag,setDisableBtnFlag]=useState(true);

  useEffect(() => {
    if (!userinfo.id) {
      judgeIsLogin();
    }
  }, [])

  useEffect(()=>{
    if(testInfo?.preExamID){
      getExamDetail({ id: testInfo?.preExamID, user_id: userinfo.id}).then((res: any) => {
        if (res && res.code === 0) {
          setPreExamInfo(res.data || {})
        } else {
          res && message.error(res.msg || "获取失败");
        }
      })
      getUserGrade({ examID: testInfo?.preExamID, userID: userinfo.id}).then((res: any) => {
        if (res && res.code === 0) {
          setPreExamGrade(res.data || {})
          if(!res.data?.isPass){
            setDisableBtnFlag(true)
          }else{
            setDisableBtnFlag(false)
          }
        } else {
          res && message.error(res.msg || "获取失败");
        }
      })
    }else{
      setDisableBtnFlag(false)
    }
  },[testInfo])

  useEffect(() => {
    initData();
    getExamDetail({ id: urlParams.id, user_id: userinfo.id }).then((res: any) => {
      if (res && res.code === 0) {
        setTestInfo(res.data || {});
      } else {
        res && message.error(res.msg || "获取失败");
      }
    })

    getUserAutoExamGrade({ examID: urlParams.id, userID: userinfo.id }).then((res: any) => {
      if (res && res.code === 0 && res.data) {
        const {data:{grade}} = res;
        setGrade(grade)
      } else {
        // res && message.error(res.msg || "获取失败");
      }
    })
    
  }, [urlParams.id])

  function initData() {
    const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify(null)) || {};
    getListRecord({ page: 1, limit: 10, examID: urlParams.id, sort: 'grade', user_id: userinfo.id }).then((res: any) => {
      if (res && res.code === 0) {
        const { records } = res.data;
        let ids: string[] = [];
        records.map((item: any) => {
          ids.push(item.userID);
          return item;
        });
        let _ids: any = Array.from(new Set(ids));
        getUserInfo({ id: _ids.join(',') }).then((response: any) => {
          if (response && response.code === 0) {
            const { user = [] } = response.data;
            if (user && user.length > 0) {
              for (let i = 0; i < records.length; i++) {
                for (let j = 0; j < user.length; j++) {
                  if (records[i].userID === user[j].id) {
                    records[i].username = user[j].userName;
                    records[i].employeeEmail = user[j].employeeEmail;
                  }
                }
              }
            }
            setTestRecordList(records || []);
          }
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }

  function startExam() {
    checkExam({ examID: urlParams.id, user_id: userinfo.id }).then((res: any) => {
      if (res && res.code === 0) {
        setIsLoading(true);
        countDown();
      } else {
        res && message.error(res.msg || "暂不能考试!");
      }
    })
  }

  function countDown() {
    let time = timeLength;
    timer = setInterval(() => {
      if (time === 1) {
        clearInterval(timer);
        setIsLoading(false);
        history.push(`/enter_exam/${urlParams.id}`);
        return;
      }
      time -= 1;
      setTimeLength(time);
    }, 1000)
  }

  function goExam() {
    history.push(`/enter_exam/${urlParams.id}`);
  }

  function goAutoExam(){
    const currUserInfo = localStorage.getItem('userinfo') ? localStorage.getItem('userinfo') : {};
    const {userId} = JSON.parse(currUserInfo as any);
    submitExamAuto({examID:urlParams.id, userID:userId}).then((res: any) => {
      if (res && res.code === 0) {
        message.success("申请考试成功，注意查收考试信息邮件！");
      } else {
        res && message.error(res.msg || "申请考试失败");
      }
    })
  }

  function goExamEnvFeedback(){
    history.push(`/exam_env_feedback/${urlParams.id}/edit`);
  }

  function goExamExpFeedback(){
    history.push(`/exam_exp_feedback/${urlParams.id}/edit`);
  }

  function goExamScoreFeedback(){
    history.push(`/manmade_exam_check/view/${urlParams.id}/see`);
  }
  
  
  function goHome() {
    history.push("/");
  }


 
  return (
    <>
      {
        isLoading && (
          <div className="enter-before">
            <div className="inner">
              <h2>{testInfo.name}</h2>
              <Spin size="large" />
              <div className="text">正在组卷中...</div>
              <div className="tips">预计等待{timeLength}秒，已等待{initTimeLength - timeLength}秒，请勿刷新页面</div>
            </div>
          </div>
        )
      }

      <div className="exam-before">
        <div className="exam-before-head">
          <div className="head">
            <div className="head-left">
              <div className="logo" onClick={goHome}>
                <img src={Logo} alt="青云" />
                <span className="line">|</span>
                <span className="text">合作伙伴支持平台</span>
              </div>
            </div>
            <div className="head-right">{userinfo.employee_name}</div>
          </div>
        </div>
        <div className="exam-before-content">
          <div className="content">
            <div className="content-left">
              <h1>{testInfo.name}</h1>
              {
                preExamInfo &&
                <Alert
                  showIcon
                  message={
                    <div className="notice">
                      请注意，通过<span className='title'>《{preExamInfo?.name}》</span> 后，您方可申请参加该考试。
                    </div>
                  }
                  type="warning"
                />
               
              }
              <img className="img"  src="/qingcloud/learning/static/media/exam_cover.94476cce.png" alt=""></img>
             
              <div className="btn-group">
              {
                testInfo.type !==2 && testInfo.isExaming === 0 && (<Button type="primary" onClick={startExam}>开始考试</Button>)
              }
              {
                testInfo.type !==2 && testInfo.isExaming === 1 && (<Button type="primary"  onClick={goExam}>进入考试</Button>)
              }
              {
                testInfo.type ===2  && grade === null &&
                <Button type="primary" disabled={disableBtnFlag} onClick={goAutoExam}>申请考试</Button>
              }
              {
                testInfo.type ===2  && grade === 0 &&
                <Button  type="primary" onClick={goExamEnvFeedback}>环境异常反馈</Button>
              }
              {
                 testInfo.type === 2  && !!grade && grade !== 0 &&
                <Button type="primary" onClick={goExamScoreFeedback}>考试得分</Button>
              }
              {
                testInfo.type === 2  && !!grade && grade !== 0 &&
               <Button type="primary" onClick={goExamExpFeedback}>考试评价</Button> 
              } 
              </div>
            </div>
            {
              testInfo.type !== 2 &&
              testRecordList.length > 0 && (
                <div className="content-right">
                  <div className="head">
                    <Divider plain>排行榜</Divider>
                  </div>
                  <div className="title">
                    <div>名次</div>
                    <div>用户名</div>
                    <div>账号</div>
                    <div>分数</div>
                  </div>
                  <ul>
                    {
                      testRecordList.map((item: any, index) => {
                        return (
                          <li key={item.id}>
                            <div>{index + 1}</div>
                            <div>{item.username}</div>
                            {
                              item.employeeEmail && (
                                <div>{item.employeeEmail.substring(0, 4)}****{item.employeeEmail.substring(item.employeeEmail.length - 6)}</div>
                              )
                            }
                            <div>{item.grade}</div>
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              )
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default BeforeAnswer;
